import { portalLink } from "../utils/portal";

function Placement() {
  return (
<section className="placement" id="placements">
      <div className="pl-left">
        <div className="eyebrow">
          <div className="eyebrow-dash"></div>
          <span className="eyebrow-text">Placements</span>
        </div>
        <h2 className="pl-title">We Don't Stop Until You're <em>Placed.</em></h2>
        <p className="pl-body">
          Through MoUs with government and private organizations nationwide,
          IPDI ensures every student finds a role that matches their skills and
          ambition.
        </p>
        <a
          href={portalLink("/student-login")}
          className="btn"
          style={{ background: "#fff", color: "var(--terra)", border: "1px solid #fff", fontSize: "0.72rem" }}
          >Start Your Journey</a
        >
      </div>
      <div className="pl-right">
        <ul className="pl-steps">
          <li className="pls">
            <span className="pls-n">01</span>
            <div>
              <div className="pls-title">Unlimited 1:1 Career Counselling</div>
              <p className="pls-desc">
                Personalized sessions to map your strengths, goals, and ideal
                career trajectory within architecture and design.
              </p>
            </div>
          </li>
          <li className="pls">
            <span className="pls-n">02</span>
            <div>
              <div className="pls-title">Portfolio &amp; Resume Building</div>
              <p className="pls-desc">
                We help craft a compelling visual portfolio and ATS-ready resume
                that stands out to top firms.
              </p>
            </div>
          </li>
          <li className="pls">
            <span className="pls-n">03</span>
            <div>
              <div className="pls-title">Interview Preparation</div>
              <p className="pls-desc">
                Mock interviews, presentation coaching, and industry-specific
                Q&amp;A with practicing professionals.
              </p>
            </div>
          </li>
          <li className="pls">
            <span className="pls-n">04</span>
            <div>
              <div className="pls-title">Interviews Scheduled by IPDI HR</div>
              <p className="pls-desc">
                Our HR team directly coordinates with partner firms and
                schedules interviews so you focus on performing.
              </p>
            </div>
          </li>
          <li className="pls">
            <span className="pls-n">05</span>
            <div>
              <div className="pls-title">Get Placed</div>
              <p className="pls-desc">
                Join 500+ alumni working in multinational firms across India and
                internationally.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Placement;
